import React from 'react';
import { useTranslation } from 'react-i18next';
import { HiddenProps } from './types';
import HiddenLayout from './HiddenLayout';
import Blocked from './Icons/Blocked';

const DefaultBlockedOverlay: React.FC<HiddenProps> = ({
  deviation,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <HiddenLayout
      deviation={deviation}
      icon={<Blocked />}
      title={t('deviationview.blocked.default')}
      {...props}
    />
  );
};
DefaultBlockedOverlay.displayName = 'DefaultBlockedOverlay';

export default DefaultBlockedOverlay;
